/**
 * Type guard to check if the given parameter is an instance of HTMLElement.
 */
export function isHTMLElement(elementMaybe) {
  return !!elementMaybe && elementMaybe instanceof HTMLElement;
}